
const _os = 'web'

function getOS() {
    return _os
}

export default {
    getOS,
}